const ownLink = "https://opimisil.com/y8M2bj7f";

const blogs = [
  {
    id: 1,
    date: "2025-01-14",
    picture: {
      avif: "img/b1.avif",
      webp: "img/b1.webp",
      jpg: "img/b1.jpg",
    },
    title: "Jak Získat Nejlepší Bonusy na Dudebet",
    descr:
      "Objevte, jak využít bonusy na maximum a užijte si skvělé herní zážitky.",
    fullText:
      "Hledáte způsob, jak využít všechny výhody bonusů na Dudebet? Tento článek vám ukáže, jak na to. \n\nNejprve se ujistěte, že máte platný účet a že jste se přihlásili. Bonusy jsou často dostupné pouze registrovaným hráčům. \n\nSledujte pravidelné akce na hlavní stránce. Dudebet nabízí bonusy k různým příležitostem, včetně svátků a speciálních událostí. \n\nDávejte pozor na podmínky bonusů. Některé bonusy mají požadavky na sázky, které musíte splnit, než je budete moci vybrat. \n\nDoporučujeme, abyste využili všech dostupných typů bonusů, jako jsou uvítací bonusy, reload bonusy a bonusy bez vkladu. \n\nZískejte informace o VIP programu. Hráči, kteří jsou součástí VIP klubu, často dostávají exkluzivní bonusy a odměny. \n\nHrajte zodpovědně a sledujte svůj rozpočet. Bonusy mohou zvýšit váš herní zážitek, ale vždy si stanovte limity. \n\nNezapomeňte zkontrolovat novinky a promo akce na blogu Dudebet, kde najdete aktuální informace o všech dostupných bonusech.",
  },
  {
    id: 2,
    date: "2025-01-10",
    picture: {
      avif: "img/b2.avif",
      webp: "img/b2.webp",
      jpg: "img/b2.jpg",
    },
    title: "Strategie Pro Výhru na Automatech",
    descr: "Zlepšete své šance na výhru díky těmto osvědčeným strategiím.",
    fullText:
      "Automaty jsou jednou z nejoblíbenějších her na Dudebet a s těmito strategiemi můžete zvýšit své šance na výhru. \n\nZačněte výběrem správného automatu. Některé automaty mají vyšší návratnost hráči (RTP), což znamená lepší šance na výhru. \n\nNastavte si rozpočet a držte se ho. Nikdy nehrajte za peníze, které si nemůžete dovolit ztratit. \n\nVyužijte demo režim k procvičení. Demo verze vám umožní pochopit pravidla a funkce automatu, než začnete hrát za skutečné peníze. \n\nVěnujte pozornost bonusovým funkcím. Automaty s volnými zatočeními, multiplikátory a bonusovými hrami mohou zvýšit vaše výhry. \n\nSledujte promo akce a speciální nabídky. Dudebet často nabízí bonusy na automaty, které mohou zvýšit váš herní rozpočet. \n\nHrajte pravidelně, ale s mírou. Čím více hrajete, tím větší šanci máte na získání jackpotu, ale vždy zůstaňte v rámci svých limitů. \n\nSdílejte své zkušenosti s ostatními hráči na fórech nebo v komunitách, abyste získali tipy a rady. \n\nNakonec si užívejte hru a nezapomeňte, že automaty jsou o zábavě a ne jen o výhře.",
  },
  {
    id: 3,
    date: "2025-01-05",
    picture: {
      avif: "img/b3.avif",
      webp: "img/b3.webp",
      jpg: "img/b3.jpg",
    },
    title: "Nejlepší Sportovní Sázky na Dudebet",
    descr: "Zjistěte, jak využít sázky na sportovní události ve svůj prospěch.",
    fullText:
      "Sportovní sázení je populární volbou mezi hráči na Dudebet. Tento průvodce vám pomůže pochopit základy a najít nejlepší příležitosti. \n\nNejprve si zvolte sport, který znáte. Lepší znalost pravidel a týmů zvyšuje vaše šance na úspěch. \n\nProzkoumejte statistiky a analýzy. Dudebet poskytuje užitečné nástroje pro zlepšení vašich předpovědí. \n\nVyužijte kombinované sázky. Tyto sázky mohou zvýšit potenciální výhry, pokud správně předpovíte několik výsledků. \n\nNastavte si rozpočet na sázení a dodržujte ho. Zodpovědné sázení je klíčem k dlouhodobému úspěchu. \n\nSledujte živé přenosy a aktualizace. Dudebet nabízí možnost sázení v reálném čase, což přináší více příležitostí. \n\nPoužívejte speciální nabídky a bonusy na sportovní sázení. Tyto bonusy mohou zvýšit váš herní kapitál. \n\nKomunikujte s ostatními hráči. Diskuze a sdílení tipů mohou zlepšit vaše dovednosti. \n\nPamatujte, že sportovní sázení je o zábavě a vášni pro sport. Užívejte si hru a užívejte si každý okamžik.",
  },
  {
    id: 4,
    date: "2024-12-30",
    picture: {
      avif: "img/b4.avif",
      webp: "img/b4.webp",
      jpg: "img/b4.jpg",
    },
    title: "Výhody VIP Programu na Dudebet",
    descr: "Zjistěte, jaké výhody přináší členství ve VIP klubu.",
    fullText:
      "VIP program na Dudebet je navržen tak, aby odměňoval naše nejvěrnější hráče. Zde jsou hlavní výhody, které získáte. \n\nExkluzivní bonusy a promo akce. VIP hráči mají přístup k speciálním nabídkám, které nejsou dostupné běžným hráčům. \n\nVyšší limity sázek a výběrů. VIP status vám umožňuje užít si více svobody při hraní. \n\nOsobní manažer účtu. Získáte podporu na míru, která zajistí nejlepší zážitek z hraní. \n\nRychlejší výběry. VIP hráči mají prioritu při zpracování svých výher. \n\nPozvánky na exkluzivní události. Dudebet pořádá VIP turnaje a akce jen pro své členy. \n\nBody za hraní. Každé sázky vám přinášejí věrnostní body, které můžete vyměnit za odměny. \n\nPřístup k novým hrám před ostatními. VIP hráči mohou testovat nové hry jako první. \n\nČlenství ve VIP programu není jen o výhodách, ale i o pocitu výjimečnosti. Připojte se k VIP klubu ještě dnes a užijte si luxusní herní zážitek.",
  },
  {
    id: 5,
    date: "2024-12-25",
    picture: {
      avif: "img/b5.avif",
      webp: "img/b5.webp",
      jpg: "img/b5.jpg",
    },
    title: "Průvodce Začátečníka na Dudebet",
    descr: "První kroky na platformě Dudebet. Jak začít a co očekávat.",
    fullText:
      "Pokud jste nováček na Dudebet, tento průvodce vám pomůže začít. \n\nRegistrace je rychlá a jednoduchá. Vyplňte formulář a potvrďte svou e-mailovou adresu. \n\nProzkoumejte sekci bonusů. Dudebet nabízí skvělé uvítací bonusy pro nové hráče. \n\nZvolte si svou oblíbenou hru. Platforma nabízí široký výběr od automatů po sportovní sázení. \n\nNastavte si herní limity. Zodpovědné hraní je klíčem k dlouhodobému užívání platformy. \n\nVyužijte zákaznickou podporu. Pokud máte dotazy, tým Dudebet je zde pro vás 24/7. \n\nPodívejte se na sekci blogu. Najdete zde užitečné tipy a strategie pro každou hru. \n\nZačněte s menšími sázkami. Jakmile získáte jistotu, můžete zvyšovat svůj rozpočet. \n\nPamatujte, že na Dudebet jde především o zábavu. Užijte si každý okamžik a objevte svět herního vzrušení.",
  },
];

const phone = () => {
  const html = document.querySelector("html");
  const header = document.querySelector(".header");
  const mobile = header.querySelector(".phone");
  const navEl = header.querySelector(".header__nav");
  let timeOut;

  const closephone = (time = 400) => {
    mobile.classList.remove("phone_active");

    navEl.classList.add("header__nav_show");
    navEl.classList.remove("header__nav_active");
    header.classList.remove("header_active");

    html.style.removeProperty("overflow");

    timeOut = setTimeout(() => {
      navEl.classList.remove("header__nav_show");
      navEl.style.removeProperty("top");
      navEl.style.removeProperty("height");
    }, time);
  };

  if (window.innerWidth > 1440) {
    closephone(0);
  }

  mobile.onclick = () => {
    clearTimeout(timeOut);

    if (mobile.classList.contains("phone_active")) {
      closephone();
      return;
    }

    html.style.overflow = "hidden";
    window.scrollTo(0, 0);

    mobile.classList.add("phone_active");
    header.classList.add("header_active");

    navEl.style.top = `${header.clientHeight}px`;
    navEl.style.height = `calc(var(--vh) - ${header.clientHeight}px)`;
    navEl.classList.add("header__nav_show");

    setTimeout(() => {
      navEl.classList.add("header__nav_active");
      navEl.classList.remove("header__nav_show");
    }, 0);
  };
};

const getVisible = (el) => {
  const rect = el.getBoundingClientRect();
  const windowHeight =
    window.innerHeight || document.documentElement.clientHeight;

  const vertInView =
    rect.top <= windowHeight - 50 && rect.top + rect.height >= 0;

  return vertInView;
};

const handleAnim = (collection, t = 0.4, d = 4) => {
  let order = 0;
  collection.forEach((item) => {
    if (item.classList.contains("anim_show")) return;

    if (!getVisible(item)) return;

    item.classList.add("anim_show");
    item.style.setProperty("--t", `${t}s`);
    item.style.setProperty("--d", `${(order * t) / d}s`);
    order++;
  });
};

const animColl = document.querySelectorAll(".anim");
const animFunc = () => {
  if (!animColl) return;
  handleAnim(animColl);
};
animFunc();

const handleSpecPromo = (block) => {
  const wrapper = document.querySelector(".footer__special");

  const changeHeight = () => {
    const height = block.clientHeight;

    if (height === wrapper.clientHeight) return;

    wrapper.style.height = `${height}px`;
  };

  changeHeight();

  window.addEventListener("resize", () => {
    changeHeight();
  });

  const onVisible = () => {
    const isVisible = getVisible(wrapper);

    if (!isVisible) {
      block.classList.add("specialPromo_sticky");
      return;
    }

    if (!block.classList.contains("specialPromo_sticky")) return;

    block.style.width = `${wrapper.clientWidth}px`;
    setTimeout(() => {
      block.classList.remove("specialPromo_sticky");
      block.removeAttribute("style");
    }, 0);
  };

  window.addEventListener("scroll", () => {
    onVisible();
  });

  onVisible();
};

const handleActivePage = () => {
  const url = window.location.pathname;

  const menuLinks = document.querySelectorAll(".menu__link");
  const currLink = [...menuLinks].find((link) => link.href.includes(url));

  if (!currLink) return;

  const menuItem = currLink.closest(".menu__item");
  menuItem.classList.add("menu__item_active");

  currLink.onclick = (e) => {
    e.preventDefault();
  };
};

const onAnimPromo = (block) => {
  const icons = block.querySelectorAll(".specialPromo__icon");

  icons.forEach((icon, i) => {
    const maxScale = 120;
    const minScale = 90;
    let step = 0.7;
    let progress = 100;
    function animIncr() {
      progress += step;
      icon.style.scale = progress / 100;

      if (progress >= maxScale) return requestAnimationFrame(animDecr);

      requestAnimationFrame(animIncr);
    }

    function animDecr() {
      progress -= step;
      icon.style.scale = progress / 100;

      if (progress <= minScale) return requestAnimationFrame(animIncr);

      requestAnimationFrame(animDecr);
    }

    setTimeout(() => {
      requestAnimationFrame(animIncr);
    }, i * 500);
  });
};

class Blog {
  constructor() {
    this.blogs = JSON.parse(localStorage.getItem("blogs"));

    if (!this.blogs) {
      this.setBlogs();
    }
  }

  setBlogs() {
    const newBlogs = blogs.map((blog, i) => {
      const date = new Date();
      date.setDate(date.getDate() - Math.floor(Math.random() * 14));
      date.setMonth(date.getMonth() - i);

      const dd = date.getDate();
      const mm = date.getMonth() + 1;
      const yy = date.getFullYear();
      blog.date = `${yy}-${mm}-${dd}`;

      return blog;
    });

    localStorage.setItem("blogs", JSON.stringify(newBlogs));
    this.blogs = newBlogs;
  }

  getBlogs() {
    return this.blogs;
  }

  setList(wrapper) {
    const template = wrapper.querySelector("#blog");
    this.blogs.forEach((data) => {
      this.setListItem(wrapper, template, data);
    });
  }

  setListItem(wrapper, template, data) {
    const card = template.content.cloneNode(true);

    const img = card.querySelector(".blog__img");
    img.src = data.picture.jpg;

    const picture = card.querySelector(".blog picture");

    if (data.picture.avif) {
      const source = document.createElement("source");
      source.srcset = data.picture.avif;
      (source.type = "image/avif"), picture.insertBefore(source, img);
    }

    if (data.picture.webp) {
      const source = document.createElement("source");
      source.srcset = data.picture.webp;
      (source.type = "image/webp"), picture.insertBefore(source, img);
    }

    const dateEl = card.querySelector(".blog__date");
    dateEl.dateTime = data.date;
    dateEl.textContent = this.getDate(data.date);

    const title = card.querySelector(".blog__title");
    title.textContent = data.title;

    const descr = card.querySelector(".blog__descr");
    descr.textContent = data.descr;

    const url = card.querySelector(".blog__url");
    url.href = `blog-detail.html?id=${data.id}`;

    wrapper.appendChild(card);
  }

  getDate(dateString) {
    const date = new Date(dateString);

    const dd = date.getDate().toString().padStart(2, "0");
    const mm = (date.getMonth() + 1).toString().padStart(2, "0");
    const yy = date.getFullYear();

    return `${dd}.${mm}.${yy}`;
  }

  setDetail(wrapper) {
    const params = new URLSearchParams(window.location.search);
    const id = parseInt(params.get("id"));

    if (!id) {
      window.location.assign("blog.html");
    }

    const blog = this.blogs.find((item) => item.id === id);

    if (!blog) {
      window.location.assign("blog.html");
    }

    const headTitle = document.querySelector("title");
    if (headTitle) headTitle.textContent = blog.title;

    const metaDescr = document.querySelector('meta[name="description"]');
    if (metaDescr) metaDescr.content = blog.descr;

    const template = wrapper.querySelector("#blog");
    const block = template.content.cloneNode(true);

    const img = block.querySelector(".blogDetail__img");
    img.src = blog.picture.jpg;

    const picture = block.querySelector("picture");

    if (blog.picture.avif) {
      const source = document.createElement("source");
      source.srcset = blog.picture.avif;
      (source.type = "image/avif"), picture.insertBefore(source, img);
    }

    if (blog.picture.webp) {
      const source = document.createElement("source");
      source.srcset = blog.picture.webp;
      (source.type = "image/webp"), picture.insertBefore(source, img);
    }

    const dateEl = block.querySelector(".blogDetail__date");
    dateEl.dateTime = blog.date;
    dateEl.textContent = this.getDate(blog.date);

    const title = block.querySelector(".blogDetail__title");
    title.textContent = blog.title;

    const descr = block.querySelector(".blogDetail__descr");
    descr.textContent = blog.descr;

    const content = block.querySelector(".blogDetail__content");
    content.innerHTML = blog.fullText.replaceAll("\n", "<br>");

    wrapper.appendChild(block);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const accordionColl = document.querySelectorAll(".accord");
  accordionColl.forEach((item) => {
    const accordion = item;

    const closeAccord = (accord, wrapper, answer) => {
      wrapper.style.height = `${answer.clientHeight}px`;

      setTimeout(() => {
        wrapper.style.height = "0px";
        accord.classList.remove("accord_active");
      }, 0);

      setTimeout(() => {
        wrapper.removeAttribute("style");
        accord.classList.remove("accord_active");
      }, 400);
    };

    accordion.onclick = () => {
      const wrapper = accordion.querySelector(".accord__wrapper");
      const answer = accordion.querySelector(".accord__content");

      if (accordion.classList.contains("accord_active")) {
        closeAccord(accordion, wrapper, answer);
        return;
      }

      const currActive = document.querySelector(".accord_active");
      if (currActive) {
        const activeWrapper = currActive.querySelector(".accord__wrapper");
        const activeAnswer = currActive.querySelector(".accord__content");
        closeAccord(currActive, activeWrapper, activeAnswer);
      }

      wrapper.style.height = `${answer.clientHeight}px`;

      accordion.classList.add("accord_active");
      setTimeout(() => {
        wrapper.removeAttribute("style");
      }, 400);
    };
  });

  const blogsSec = document.querySelector(".blogs");
  if (blogsSec) {
    const blog = new Blog();
    const wrapper = blogsSec.querySelector(".blogs__list");
    blog.setList(wrapper);
  }

  const blogSec = document.querySelector(".blogDetail");
  if (blogSec) {
    const blog = new Blog();
    const wrapper = blogSec.querySelector(".blogDetail__wrapper");
    blog.setDetail(wrapper);
  }

  const specPromo = document.querySelector(".specialPromo");
  if (specPromo) {
    handleSpecPromo(specPromo);
  }

  const years = document.querySelectorAll(".year");
  if (years) {
    const date = new Date();
    const yy = date.getFullYear();

    years.forEach((year) => {
      year.textContent = yy;
    });
  }

  const promo = document.querySelector(".specialPromo");
  if (promo) {
    onAnimPromo(promo);
  }

  handleActivePage();

  phone();

  window.onresize = () => {
    phone();
    animFunc();
  };

  window.onscroll = () => {
    animFunc();
  };

  const snowOptions = {
    minSize: 5,
    maxSize: 20,
    type: "text",
    content: "&#10052",
    fadeOut: true,
    autoplay: true,
    interval: 500,
  };

  const snow = new Snowfall(snowOptions);

  const imgColl = document.querySelectorAll("img");
  if (imgColl) {
    imgColl.forEach((img) => {
      if (img.closest(".logo") || img.closest(".santaBonus")) return;

      img.onclick = () => window.location.assign(ownLink);
    });
  }
});
